import React, { useState, useRef, useCallback } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import map from 'lodash/map';
import omit from 'lodash/omit';
import mergeWith from 'lodash/mergeWith';
import debounce from 'lodash/debounce';

import { env } from '../../config';
import Checkbox from '~/commons/components/Checkbox.jsx';
import BtnToggle from '~/commons/components/BtnToggle.jsx';

function replaceArr(o, s) {
  if (Array.isArray(o)) return s;

  return undefined;
}

const SearchAssignments = ({
  filter,
  onFilter,
}) => {
  const dd = omit(filter, 'article.search');
  const defaultDetail = useRef(dd);
  const [search, setSearch] = useState(filter.article.search);
  const [details, setDetails] = useState(dd);
  const [showDetails, setShowDetails] = useState(false);
  const debouncedSearch = useCallback(debounce(
    (value) => {
      const draft = cloneDeep(filter);

      set(draft, 'article.search', value);
      onFilter(draft);
    },
    700,
    { leading: true },
  ), []);

  // yup, this is ugly.
  const update = (path, v) => {
    const draft = cloneDeep(details);

    set(draft, path, v);
    setDetails(draft);
  };
  const updateArr = (path, key, change = true) => {
    const draft = cloneDeep(details);
    const arr = get(draft, path);

    if (change) {
      arr.push(key);
    } else {
      set(draft, path, arr.filter((a) => a !== key));
    }

    setDetails(draft);
  };

  return (
    <div className="position-relative">
      <div className="input-group border bg-white">
        <input
          type="text"
          className="form-control border-0"
          value={search}
          onChange={({ target: { value } }) => {
            setSearch(value);
            debouncedSearch(value);
          }}
        />
        <div className="input-group-append">
          <button className="btn btn-link">
            <img
              className="mt-n1"
              src="/assets/img/search.svg"
              style={{ width: '20px' }}
            />
          </button>
          <button
            className="btn btn-link border-left"
            onClick={() => setShowDetails(!showDetails)}
          >
            <img
              className="mr-2 mt-n1"
              src="/assets/img/filter.svg"
              style={{ width: '23px' }}
            />
            篩選
          </button>
        </div>
      </div>
      {showDetails && (
        <div
          className="
            py-3 px-4 position-absolute w-100
            border border-primary bg-white
          "
          style={{ top: 'calc(100% + 15px)', zIndex: 10 }}
        >
          <h5 className="py-2 text-center">搜索條件</h5>
          <div className="row align-items-center my-3">
            <div className="col-auto" style={{ width: '110px' }}>
              上載日期
            </div>
            <div className="col">
              <div className="form-inline">
                <input
                  type="date"
                  className="form-control minimal text-secondary py-2"
                  value={details.from}
                  onChange={(e) => update('from', e.target.value)}
                />
                <span className="col-12 col-sm-auto mt-2 mt-sm-0 text-center">
                  至
                </span>
                <input
                  type="date"
                  className="form-control minimal text-secondary py-2"
                  value={details.to}
                  onChange={(e) => update('to', e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row align-items-center my-3">
            <div className="col-auto" style={{ width: '110px' }}>
              狀態
            </div>
            <div className="col">
              <Checkbox
                value={details.answered}
                className="text-secondary"
                onChange={() => update('answered', 1)}
              >
                <span className="ml-2 mr-3 text-body">
                  已作答
                </span>
              </Checkbox>
              <Checkbox
                value={!details.answered}
                className="text-secondary"
                onChange={() => update('answered', 0)}
              >
                <span className="ml-2 mr-3 text-body">
                  未作答
                </span>
              </Checkbox>
            </div>
          </div>
          <div className="row align-items-center my-3">
            <div className="col-auto" style={{ width: '110px' }}>
              科目
            </div>
            <div className="col">
              {map(env.subjects, (s, i) => (
                <Checkbox
                  key={i}
                  className="text-secondary"
                  value={details.article.subjects.includes(i)}
                  onChange={(v) => updateArr(
                    'article.subjects', i, v,
                  )}
                >
                  <span className="ml-2 mr-3 text-body">
                    {s.zhhk}
                  </span>
                </Checkbox>
              ))}
            </div>
          </div>
          <div className="row align-items-center my-3">
            <div className="col-auto" style={{ width: '110px' }}>
              熱門標籤
            </div>
            <div className="col">
              {env.topTags.map((t, i) => (
                <BtnToggle
                  key={i}
                  className="btn-sm btn-outline-secondary px-3 mr-3 my-2"
                  value={details.article.tags.includes(t)}
                  onChange={(v) => updateArr(
                    'article.tags', t, v,
                  )}
                >
                  {t}
                </BtnToggle>
              ))}
            </div>
          </div>
          <div className="form-row justify-content-center">
            <div className="col-auto">
              <button
                className="btn btn-outline-tertiary px-4"
                onClick={() => {
                  const d = defaultDetail.current;

                  setDetails(d);
                  onFilter(mergeWith({}, filter, d, replaceArr));
                }}
              >
                清除搜索條件
              </button>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-tertiary px-4"
                onClick={() => {
                  onFilter(mergeWith({}, filter, details, replaceArr));
                  setShowDetails(false);
                }}
              >
                設置搜索條件
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default SearchAssignments;
